import type { IconData } from '@stacksjs/iconify-core'

export const panoramicScreenFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M6.24 7.557a3.34 3.34 0 0 0-2.826.28c-.807.476-1.485 1.344-1.551 2.48C1.707 12.975 1.5 17.7 1.5 24s.207 11.025.363 13.684c.066 1.136.744 2.003 1.551 2.48c.8.472 1.84.636 2.826.28C8.92 39.472 14.544 38 24 38s15.079 1.472 17.76 2.444a3.34 3.34 0 0 0 2.826-.28c.807-.477 1.485-1.344 1.551-2.48c.156-2.659.363-7.384.363-13.684s-.207-11.025-.363-13.683c-.066-1.136-.744-2.004-1.551-2.48a3.34 3.34 0 0 0-2.826-.28C39.08 8.527 33.457 10 24 10C14.544 10 8.921 8.528 6.24 7.557\"/><path fill=\"#2859c5\" d=\"M14.006 9.361A2 2 0 0 0 14 9.5v29q0 .07.006.139A61 61 0 0 1 17 38.297V9.703a61 61 0 0 1-2.994-.342M31 9.703v28.594a61 61 0 0 1 2.994.342q.006-.068.006-.14v-29q0-.069-.006-.138q-1.387.196-2.994.342\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default panoramicScreenFlat
